'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z' });

var SwapCalls = function SwapCalls(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SwapCalls = (0, _pure2.default)(SwapCalls);
SwapCalls.muiName = 'SvgIcon';

exports.default = SwapCalls;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SwapCalls.js
// module id = 2910
// module chunks = 0